import { render } from "./sidebarMenuItem.vue?vue&type=template&id=024b6c18&scoped=true"
import script from "./sidebarMenuItem.vue?vue&type=script&lang=js"
export * from "./sidebarMenuItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "../style.less?vue&type=style&index=0&module=true&lang=less&external"
cssModules["$style"] = style0
import "./sidebarMenuItem.vue?vue&type=style&index=1&id=024b6c18&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-024b6c18"]])

export default __exports__